export const ADD_ALL_NOTIFICATIONS = "ADD_ALL_NOTIFICATIONS";
export const ADD_NOTIFICATION_COUNT = "ADD_NOTIFICATION_COUNT";
export const CLEAR_NOTIFICATION_DATA = "CLEAR_NOTIFICATION_DATA";
export const INCREASE_NOTIFICATION_COUNT = "INCREASE_NOTIFICATION_COUNT";
export const ADD_NOTIFICATIONS = "ADD_NOTIFICATIONS";
